export default "__VITE_ASSET__BvDEmvB___"